import { AppStoreEnum } from '#lib/enums'
import { defineStore } from 'pinia'

export interface MaintenanceGames {
  isMaintain: boolean
  startTime: string
  endTime: string
}

export const useMaintenanceGamesStore = defineStore(
  AppStoreEnum.MaintenanceGames,
  {
    state: (): MaintenanceGames => ({
      isMaintain: false,
      startTime: '',
      endTime: '',
    }),
    persist: false,
    actions: {
      setMaintenanceGames(isMaintain: boolean, startTime = '', endTime = '') {
        this.isMaintain = isMaintain
        this.startTime = startTime
        this.endTime = endTime
      },
      resetMaintenanceGames() {
        this.isMaintain = false
        this.startTime = ''
        this.endTime = ''
      },
    },
  },
)
